export class RegionDailyAverageEntity {
  id?: string
  regionId?: number
  regionName?: string | null
  recordDate?: string
  totalActiveDeliveryMinutes?: number
  totalOnlineMinutes?: number
  totalCompletedOrders?: number
  avgUtilization?: number | null
  avgOrdersPerHour?: number | null
  createdAt?: string
  updatedAt?: string
}
